// Lightweight i18n translation table for EN / PT-BR
// Keys are English-ish camelCase; values per locale.

export const LOCALES = [
  { code: "en", label: "English", short: "EN" },
  { code: "pt", label: "Português (BR)", short: "PT" },
];

const dict = {
  // Header / nav
  "nav.dashboard": { en: "Dashboard", pt: "Painel" },
  "nav.network": { en: "Connectivity & SD-WAN", pt: "Conectividade & SD-WAN" },
  "nav.soc": { en: "Security (SOC)", pt: "Segurança (SOC)" },
  "nav.playbooks": { en: "Automation & Playbooks", pt: "Automação & Playbooks" },
  "nav.analytics": { en: "Analytics & Reports", pt: "Analytics & Relatórios" },
  "nav.telemetry": { en: "Observability & Telemetry", pt: "Observabilidade & Telemetria" },
  "nav.agents": { en: "Agentic Administration", pt: "Administração Agêntica" },
  "nav.section_ops": { en: "Operations", pt: "Operações" },

  "header.system": { en: "System", pt: "Sistema" },
  "header.operational": { en: "Operational", pt: "Operacional" },
  "header.scenario": { en: "Scenario", pt: "Cenário" },

  // Dashboard
  "dash.subtitle": { en: "Operations Cockpit · Live", pt: "Cockpit Operacional · Ao vivo" },
  "dash.title": { en: "Mission Control", pt: "Controle Operacional" },
  "dash.posture": { en: "Real-time posture across", pt: "Postura em tempo real para" },
  "dash.refresh": { en: "Refresh", pt: "Atualização" },
  "dash.refresh_every": { en: "every 20s", pt: "a cada 20s" },

  "kpi.availability": { en: "Overall Availability", pt: "Disponibilidade Geral" },
  "kpi.critical_alerts": { en: "Active Critical Alerts", pt: "Alertas Críticos Ativos" },
  "kpi.last_24h": { en: "last 24h", pt: "últimas 24h" },
  "kpi.connected_units": { en: "Connected Remote Units", pt: "Unidades Remotas Conectadas" },
  "kpi.online_of": { en: "online of", pt: "online de" },
  "kpi.compliance": { en: "Security Compliance Score", pt: "Score de Conformidade de Segurança" },

  // Map panel
  "map.title": { en: "Geographic Map · Remote Units", pt: "Mapa Geográfico · Unidades Remotas" },
  "map.hint": { en: "Click a pin for unit details", pt: "Clique em um pino para detalhes da unidade" },
  "map.healthy": { en: "HEALTHY", pt: "SAUDÁVEL" },
  "map.warning": { en: "WARNING", pt: "ALERTA" },
  "map.down": { en: "DOWN", pt: "INDISPONÍVEL" },
  "map.fiber": { en: "FIBER", pt: "FIBRA" },
  "map.wireless": { en: "WIRELESS", pt: "WIRELESS" },
  "map.region": { en: "PERNAMBUCO · BR", pt: "PERNAMBUCO · BR" },
  "map.units_count": { en: "UNITS", pt: "UNIDADES" },

  // Traffic
  "traffic.title": { en: "Network Traffic · 24h", pt: "Tráfego de Rede · 24h" },
  "traffic.subtitle": { en: "Inbound vs Outbound · Mbps", pt: "Entrada vs Saída · Mbps" },
  "traffic.peak_total": { en: "Peak Total", pt: "Pico Total" },
  "traffic.avg_in": { en: "Avg Inbound", pt: "Média Entrada" },
  "traffic.avg_out": { en: "Avg Outbound", pt: "Média Saída" },

  // Critical alerts table
  "alerts.recent_critical": { en: "Recent Critical Alerts", pt: "Alertas Críticos Recentes" },
  "alerts.actions_trigger": { en: "Actions trigger remediation playbooks", pt: "As ações disparam playbooks de remediação" },
  "alerts.severity": { en: "Severity", pt: "Severidade" },
  "alerts.unit": { en: "Unit", pt: "Unidade" },
  "alerts.event": { en: "Event Description", pt: "Descrição do Evento" },
  "alerts.duration": { en: "Duration", pt: "Duração" },
  "alerts.action": { en: "Action", pt: "Ação" },
  "alerts.remediate": { en: "Remediate", pt: "Remediar" },
  "alerts.running": { en: "Running...", pt: "Executando..." },
  "alerts.none": { en: "No critical alerts", pt: "Nenhum alerta crítico" },

  // Scenario labels
  "scenario.profile.pristine": { en: "PRISTINE", pt: "OPERAÇÃO IDEAL" },
  "scenario.profile.outage": { en: "OUTAGE", pt: "APAGÃO" },
  "scenario.profile.incident": { en: "INCIDENT", pt: "INCIDENTE" },
  "scenario.profile.mixed": { en: "MIXED", pt: "OPERAÇÃO NORMAL" },
  "scenario.live": { en: "Live (now)", pt: "Ao vivo (agora)" },

  // Misc
  "common.live": { en: "LIVE", pt: "AO VIVO" },
  "common.execute": { en: "Execute", pt: "Executar" },
  "common.running": { en: "Running...", pt: "Executando..." },
  "common.run": { en: "Run", pt: "Executar" },
  "common.reset": { en: "Reset", pt: "Reiniciar" },
  "common.standby": { en: "Standby", pt: "Em espera" },

  // Network page
  "network.subtitle": { en: "Network Operations · Connectivity & SD-WAN", pt: "Operações de Rede · Conectividade & SD-WAN" },
  "network.title": { en: "Edge Fabric", pt: "Malha de Borda" },
  "network.desc_suffix": { en: "multi-vendor SD-WAN", pt: "SD-WAN multi-fabricante" },
  "network.tunnels": { en: "SD-WAN Tunnels", pt: "Túneis SD-WAN" },
  "network.tunnels_subtitle": { en: "All tunnels · per remote unit · per carrier", pt: "Todos os túneis · por unidade · por operadora" },
  "network.qos": { en: "Link Quality (QoS)", pt: "Qualidade do Link (QoS)" },
  "network.qos_subtitle": { en: "Latency · Jitter · Packet Loss — per carrier · real-time", pt: "Latência · Jitter · Perda de Pacotes — por operadora · tempo real" },
  "network.failover_simulator": { en: "Link Failure Simulator", pt: "Simulador de Queda de Link" },
  "network.topology": { en: "Topology · Pernambuco", pt: "Topologia · Pernambuco" },
  "network.simulate_outage": { en: "Simulate Primary Link Outage", pt: "Simular Queda do Link Primário" },
  "network.outage_detected": { en: "Outage Detected", pt: "Queda Detectada" },
  "network.orchestrating": { en: "Orchestrating Failover...", pt: "Orquestrando Failover..." },
  "network.failover_success": { en: "Failover Successful", pt: "Failover Bem-Sucedido" },
  "network.remote_unit": { en: "Remote Unit", pt: "Unidade Remota" },
  "network.streaming": { en: "STREAMING", pt: "TRANSMITINDO" },

  // SOC page
  "soc.subtitle": { en: "Security Operations · Tier 2", pt: "Operações de Segurança · Tier 2" },
  "soc.title": { en: "SOC Console", pt: "Console SOC" },
  "soc.desc": { en: "Federated firewalls · SIEM · EDR · IAM · threat intelligence", pt: "Firewalls federados · SIEM · EDR · IAM · inteligência de ameaças" },
  "soc.threats_by_type": { en: "Threats Blocked by Type", pt: "Ameaças Bloqueadas por Tipo" },
  "soc.threats_subtitle": { en: "Last 7 days · across all federated firewalls", pt: "Últimos 7 dias · em todos os firewalls federados" },
  "soc.firewalls": { en: "Security Gateways · Firewalls", pt: "Gateways de Segurança · Firewalls" },
  "soc.firewalls_subtitle": { en: "Status, uptime, policy version per remote unit", pt: "Status, uptime, versão da política por unidade" },
  "soc.incident_simulator": { en: "Security Incident Simulator", pt: "Simulador de Incidente de Segurança" },
  "soc.simulate_bf": { en: "Simulate Brute Force Attack on HQ", pt: "Simular Ataque de Força Bruta no HQ" },
  "soc.bf_detected": { en: "Brute Force Attack Detected", pt: "Ataque de Força Bruta Detectado" },
  "soc.triggering_playbook": { en: "Triggering Security Playbook...", pt: "Disparando Playbook de Segurança..." },
  "soc.attack_mitigated": { en: "Attack Mitigated", pt: "Ataque Mitigado" },
  "soc.active_alerts": { en: "Active Security Alerts", pt: "Alertas de Segurança Ativos" },
  "soc.active_alerts_sub": { en: "Triage queue · click an alert to mitigate", pt: "Fila de triagem · clique para mitigar" },
  "soc.stat_active": { en: "Active", pt: "Ativos" },
  "soc.stat_investigating": { en: "Investigating", pt: "Investigando" },
  "soc.stat_mitigated": { en: "Mitigated", pt: "Mitigados" },
  "soc.stat_critical": { en: "Critical Severity", pt: "Severidade Crítica" },

  // Playbooks page
  "playbooks.subtitle": { en: "Automation & Playbooks · Catalog & History", pt: "Automação & Playbooks · Catálogo & Histórico" },
  "playbooks.title": { en: "Playbooks", pt: "Playbooks" },
  "playbooks.desc": { en: "Enable, disable and trigger remediation workflows.", pt: "Habilite, desabilite e dispare fluxos de remediação." },
  "playbooks.executions": { en: "executions on record", pt: "execuções registradas" },
  "playbooks.execution_console": { en: "Execution Console", pt: "Console de Execução" },
  "playbooks.history": { en: "Automation History", pt: "Histórico de Automação" },
  "playbooks.disabled": { en: "DISABLED", pt: "DESABILITADO" },
  "playbooks.on": { en: "On", pt: "Ligado" },
  "playbooks.off": { en: "Off", pt: "Desligado" },
  "playbooks.col_when": { en: "Timestamp", pt: "Quando" },
  "playbooks.col_playbook": { en: "Playbook", pt: "Playbook" },
  "playbooks.col_triggered_by": { en: "Triggered By", pt: "Disparado Por" },
  "playbooks.col_status": { en: "Status", pt: "Status" },
  "playbooks.col_details": { en: "Details", pt: "Detalhes" },

  // Map popover labels
  "map.simulate_drop": { en: "Simulate Link Drop", pt: "Simular Queda de Link" },
};

export function t(key, locale) {
  const entry = dict[key];
  if (!entry) return key;
  return entry[locale] || entry.en || key;
}
